<template>
  <v-container fluid grid-list-md>
    <v-layout justify-center row wrap>
      <v-flex row xs12>
        <v-stepper v-model="step" non-linear>
          <v-stepper-header>
            <v-stepper-step step="1" edit-icon="check" editable :complete="step > 1 || starters.length > 0">Turnier
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" edit-icon="check" :editable="!loading" :complete="starters.length > 0">Starter
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" edit-icon="check" :editable="!loading && starters.length > 0 && !selectionIsDirty"
                            :complete="hasAllStarterRegistrations && !selectionIsDirty">Meldungen
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step v-if="selectedEvent && selectedEvent.generate_invoices"
                            step="4"
                            edit-icon="check"
                            :editable="!loading && hasAllStarterRegistrations"
                            :complete="payment_method !== null && hasAllStarterRegistrations"
            >{{ payNow ? 'Zahlart' : 'Abschluss' }}
            </v-stepper-step>

            <v-divider v-if="selectedEvent && selectedEvent.generate_invoices && payNow"></v-divider>

            <v-stepper-step v-if="selectedEvent && payNow"
                            :step="selectedEvent.generate_invoices ? 5 : 4"
                            edit-icon="check"
                            :editable="!loading && hasAllStarterRegistrations && payment_method !== null"
            >Übersicht
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <first-step
                  v-if="events.loaded"
                  :events="events"
                  :loading="loading || !events.loaded"
                  :disabled="loading || !events.loaded"
                  v-model="selectedEvent"
              ></first-step>

              <v-btn class="right mx-0 pl-2 pr-2"
                     :disabled="!events.loaded || loading || selectedEvent === null"
                     color="primary"
                     @click.native="forward()"
                     v-t="'continue'"
              ></v-btn>
              <v-btn class="mx-0 pl-2 pr-2"
                     :disabled="loading"
                     @click="cancel"
                     v-t="'cancel'"
              ></v-btn>
            </v-stepper-content>
            <v-stepper-content step="2">
              <second-step v-if="parseInt(step) === 2"
                           :event="selectedEvent"
                           :value.sync="starters"
                           :isDirty.sync="selectionIsDirty"
                           @forward="forward"
                           @back="back"
              ></second-step>
            </v-stepper-content>

            <v-stepper-content step="3">
              <third-step v-if="parseInt(step) === 3"
                          :event="selectedEvent"
                          :starters.sync="starters"
                          @starterRegistrationDeleted="loadStarters"
              ></third-step>

              <v-btn class="right mx-0 pl-2 pr-2"
                     :disabled="!hasAllStarterRegistrations"
                     color="primary"
                     @click.native="forward()"
                     v-t="'continue'"
              ></v-btn>

              <v-btn class="right mx-0"
                     :disabled="loading"
                     flat
                     @click.native="back()"
                     v-t="'back'"
              ></v-btn>
            </v-stepper-content>

            <v-stepper-content step="4" v-if="selectedEvent && selectedEvent.generate_invoices">
              <v-container fluid grid-list-xs class="pa-1" v-show="!payNow">
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-btn block :large="!$vuetify.breakpoint.xs" outline to="/user/events">Zur späteren Bearbeitung
                      speichern
                      <v-icon right class="hidden-xs-only">save_alt</v-icon>
                    </v-btn>
                    <h2 class="text-xs-center">Meldungen können nachträglich noch geändert werden.</h2>
                  </v-flex>

                  <v-flex class="hidden-md-and-up">
                    <v-divider></v-divider>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-btn block :large="!$vuetify.breakpoint.xs" outline @click="payNow = true"><span
                        class="hidden-xs-only">Meldung&nbsp;</span>zahlungspflichtig abschließen
                      <v-icon right class="hidden-xs-only">arrow_forward</v-icon>
                    </v-btn>
                    <h2 class="text-xs-center">Meldungen können nachträglich nicht mehr geändert werden.</h2>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-slide-y-transition>
                <div v-show="payNow" :key="'second'">
                  <fourth-step v-if="parseInt(step) === 4"
                               :event="selectedEvent"
                               :starters.sync="starters"
                               :value.sync="payment_method"
                               :use-balance.sync="useBalance"
                               @forward="forward"
                               @back="back"
                  ></fourth-step>
                </div>
              </v-slide-y-transition>
            </v-stepper-content>

            <v-stepper-content v-if="selectedEvent && payNow" :step="selectedEvent.generate_invoices ? 5 : 4">
              <fifth-step v-if="parseInt(step) === (selectedEvent.generate_invoices ? 5 : 4)"
                          :event="selectedEvent"
                          :starters.sync="starters"
                          :payment-method="payment_method"
                          :use-balance="useBalance"
                          @back="back"
                          @submit="submitted = true; $router.push(`/user/event-registration-list/${selectedEvent.id}`)"
                          @changeFinalState="step = 3"
              ></fifth-step>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import FirstStep from './event-registration-steps/First';
import SecondStep from './event-registration-steps/Second';
import ThirdStep from './event-registration-steps/Third';
import FourthStep from './event-registration-steps/Fourth';
import FifthStep from './event-registration-steps/Fifth';


export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep
  },
  data() {
    return {
      loading: false,
      conditions: false,
      selectionIsDirty: false,
      submitted: false,
      payNow: false,
      useBalance: false,
      selectedEvent: null,
      payment_method: null,
      starters: [],
      selectedStarterTemplates: [],
      step: 0
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.submitted && this.starters.length > 0) {
      //next(false);
      this.$store.commit('confirm', {
        headline: 'Anmeldevorgang verlassen?',
        text: this.$t('questions.leave_registration'),
        callback: () => {
          this.$store.dispatch('loadStarters').then(() => {
            next(true);
          });
        }
      });
    } else {
      this.$store.dispatch('loadStarters').then(() => {
        next(true);
      });
    }
  },
  watch: {
    step() {
      if (this.step === 2) {
        this.selectionIsDirty = false;
      }
    },
    selectedEvent(event) {
      if (event && !event.generate_invoices) {
        this.payment_method = 'no_payment';
        this.payNow = true;
      }
    }
  },
  computed: {
    hasAllStarterRegistrations() {
      return this.starters !== undefined && this.starters.length > 0 && !_.some(this.starters, s => s.starter_registrations.length === 0)
    },
    ...mapState(['events', 'starterTemplates', 'starterTypes'])
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.selectedEvent = this.events.items.find(e => e.id === parseInt(this.$route.params.id));
    }

    this.loadStarters();
  },
  methods: {
    loadStarters() {
      this.loading = true;
      axios.get('/api/v1/starters', {
        params: {event_id: this.selectedEvent.id}
      }).then(response => {
        if (!response.data.success) {
          return;
        }

        this.loading = false;
        this.$set(this, 'starters', response.data.data);

        if (this.starters.length === 0 && parseInt(this.step) === 3) {
          this.step = 2;
        }
      });
    },
    forward() {
      this.selectionIsDirty = false;
      this.step++;
    },
    back() {
      switch (this.step - 1) {
        case 1:
          this.$set(this, 'starters', []);
          break;
      }

      this.step--;
    },
    cancel() {
      this.$router.go(-1);
    },
    saveForLater() {
      this.$store.dispatch('loadStarters').then(() => {
        next(true);
      });
    }
  }
}
</script>
